import { useMemo } from 'react';
import {
  Button,
  Typography
} from 'src/components/common';

import cx from './viewAction.module.scss';
import { TActionButton } from './viewCohort.types';
import { MdAdd } from 'react-icons/md';
import { useAppSelector } from 'src/store/hooks';
import { formatDate } from 'src/utils';
import { calculateRemainingTime } from 'src/utils/formatDate/formatDate';

const CohortAction = () => {
  const { viewCohort }: any = useAppSelector((store: any) => store.cohort);
  if (!viewCohort) {
    return <></>
  }
  const daysRemainingMiliSeconds = +new Date(viewCohort?.endDate) - +new Date(viewCohort?.startDate);
  const daysRemainingDate = new Date(daysRemainingMiliSeconds);

  return (
    <div className={cx.cohortActions}>
      <div className={cx.actions}>
        <div className={cx.header}>
          <Typography variant="subHeading-2" fontWeight="semiBold">
            {viewCohort?.cohortTitle}
          </Typography>
          <div className={cx.dates}>
            <p>Start date: {formatDate({ dateString: viewCohort?.startDate })}</p>
            <p>End Date : {formatDate({ dateString: viewCohort?.endDate })}</p>
            <p>({calculateRemainingTime(viewCohort?.endDate)} remaining)</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CohortAction;
